export const FORM_ID_REGISTRATION: string = 'form-registration';
export const FORM_ID_VERIFICATION: string = 'form-verification';
export const FORM_ID_LOGIN: string = 'form-login';
export const FORM_ID_FORGOT_PASSWORD: string = 'form-forgot-password';
export const FORM_ID_PASSWORD_RECOVERY: string = 'form-password-recovery';
export const FORM_ID_VERIFICATION_SETUP: string = 'form-verification-setup';
export const FORM_ID_SEARCH_BAR: string = 'form-search-bar';
export const FORM_ID_SETTINGS_ACCOUNT_LIST: string = 'form-settings-account-list';
export const FORM_ID_SETTINGS_ACCOUNT: string = 'form-settings-account';
export const FORM_ID_SETTINGS_USER: string = 'form-settings-user';
export const FORM_ID_SETTINGS_PROFILE: string = 'form-settings-profile';
export const FORM_ID_SETTINGS_NOTIFICATIONS: string = 'form-settings-notifications';
export const FORM_ID_SETTINGS_SECURITY: string = 'form-settings-security';
export const FORM_ID_SETTINGS_USER_LIST: string = 'form-settings-user-list';
export const FORM_ID_SETTINGS_DEAL_TEMPLATE_LIST: string = 'form-settings-deal-template-list';
export const FORM_ID_SETTINGS_PORTFOLIO_GROUP_LIST: string = 'form-settings-portfolio-group-list';
export const FORM_ID_SETTINGS_PORTFOLIO_GROUP: string = 'form-settings-portfolio-group';
export const FORM_ID_SETTINGS_PORTFOLIO: string = 'form-settings-portfolio';
export const FORM_ID_SETTINGS_DEAL_TEMPLATE: string = 'form-settings-deal-template';
export const FORM_ID_ASSET_LIST: string = 'form-asset-list';
export const FORM_ID_ASSET: string = 'form-asset';
export const FORM_ID_ACTIVITY_LIST: string = 'form-activity-list';
export const FORM_ID_ACTIVITY: string = 'form-activity';
export const FORM_ID_DEAL_LIST: string = 'form-deal-list';
export const FORM_ID_DEAL: string = 'form-deal';
export const FORM_ID_CONTACT_LIST: string = 'form-contact-list';
export const FORM_ID_CONTACT: string = 'form-contact';
export const FORM_ID_REPORT: string = 'form-report';
